import "core-js/modules/es6.regexp.flags";
import "core-js/modules/es6.function.name";

/** @jsx _j **/

/** @jsxFrag _f **/
var _require = require('astroturf'),
    _j = _require.jsx,
    _f = _require.F;

import TsDocTypeSignature from './TsDocTypeSignature';
import { getReadableName } from './utils/tsDocTypeExpression';

function TsDocTitleSignature(_ref) {
  var _definition$signature;

  var definition = _ref.definition,
      className = _ref.className,
      title = _ref.title,
      _ref$showSignature = _ref.showSignature,
      showSignature = _ref$showSignature === void 0 ? true : _ref$showSignature,
      _ref$wrap = _ref.wrap,
      _ = _ref$wrap === void 0 ? false : _ref$wrap;

  if ((_definition$signature = definition.signatures) === null || _definition$signature === void 0 ? void 0 : _definition$signature.length) {
    definition = definition.signatures[0];
  }

  if (!title && definition.name) {
    title = _j("code", null, getReadableName(definition), definition.flags.isOptional && '?');
  }

  return _j("div", {
    className: className,
    css: [require("./TsDocTitleSignature-CssProp1_div.module.css"), []]
  }, title, showSignature && _j(TsDocTypeSignature, {
    definition: definition,
    arrowStyle: true
  }));
}

export default TsDocTitleSignature;